import EventEmitter from '../EventEmitter';
import ConfirmDialogHTML from './confirmDialog.html';
import ConfirmDialogCSS from './confirmDialog.css';

export default class ConfirmDialog extends EventEmitter {
	constructor() {
		super();

		this._backdrop = document.createElement('div');
		this._backdrop.className = 'szn-dd-backdrop';
		this._backdrop.innerHTML = ConfirmDialogHTML;

		this._style = document.createElement('style');
		this._style.innerHTML = ConfirmDialogCSS;

		this._dialog = this._backdrop.getElementsByClassName('szn-dd')[0];
		this._title = this._dialog.getElementsByClassName('szn-dd-title')[0];
		this._content = this._dialog.getElementsByClassName('szn-dd-content')[0];
		this._confirmBtn = this._dialog.getElementsByClassName('szn-dd-confirm')[0];
		this._cancelBtn = this._dialog.getElementsByClassName('szn-dd-cancel')[0];

		this._confirmBtn.addEventListener('click', event => {
			this.hide();
			this.fire('confirm');
		});

		this._cancelBtn.addEventListener('click', event => {
			this.hide();
			this.fire('decline');
		});

		this._backdrop.addEventListener('click', event => {
			if (event.target !== this._backdrop) {
				return;
			}
			this.hide();
			this.fire('decline');
		});
	}

	show({ title, content, actionText, cancelText }) {
		this._title.innerText = title;
		this._content.innerText = content;
		this._confirmBtn.innerText = actionText;
		this._cancelBtn.innerText = cancelText;

		document.body.appendChild(this._style);
		document.body.appendChild(this._backdrop);
		document.body.style.overflow = 'hidden';

		this._backdrop.offsetHeight;

		this._dialog.style.transform = 'scale(1)';
		this._dialog.style.opacity = this._backdrop.style.opacity = '1';
	}

	hide() {
		const removeElementsFromDOM = () => {
			this._backdrop.remove();
			this._style.remove();

			this._dialog.removeEventListener('transitionend', removeElementsFromDOM);
		};
		this._dialog.addEventListener('transitionend', removeElementsFromDOM);

		this._dialog.style.transform = 'scale(0.5)';
		this._dialog.style.opacity = this._backdrop.style.opacity = '0';
		document.body.style.overflow = null;
	}
}
